import { useState } from 'react'

export const Login = ({
  onLogin,
  returnError,
}: {
  onLogin: (token: string) => void
  returnError?: string
}) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(
    returnError !== undefined ? returnError : '',
  )

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    try {
      const response = await fetch(`/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      })
      const data = await response.json()
      if (response.ok) {
        onLogin(data.token)
      } else {
        setError(data.error)
      }
    } catch (err) {
      console.error(err)
      setError('An error occurred')
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto mt-8 p-4 border rounded shadow"
    >
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </label>
      </div>
      {error && <div className="mb-4 text-red-500 text-sm">{error}</div>}
      <button
        type="submit"
        className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Login
      </button>
    </form>
  )
}
